import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
`;

export const RoundButtonWrapper = styled.div`
  position: absolute;
  bottom: 48px;
  left: 68px;
`;
